import camelCase from "lodash/camelCase"

import deepMapKeys from "./deepMapKeys"

// Camel case recursively all the keys of the object
const deepCamelCaseKeys = (object: object): object =>
  deepMapKeys(object, (_value, key) => camelCase(key))

export default deepCamelCaseKeys
